































































































































































































































import { Component, Prop } from "vue-property-decorator";
import { ITag, Tag } from "@/models/tag.entity";
import { TagDataAccessLayer } from "@/store/modules/access-layers/tag.access-layer";
import { ConfigModule } from "@/store/modules/config";
import { $t } from "@/lib/utility/t";
import { handleError } from "@/lib/utility/handleError";
import { IAction, IChips } from "@/components/utility/mmmint/MHeader.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import TagChip from "@/components/tag/TagChip.vue";
import IconSelect from "@/components/utility/IconSelect.vue";
import { IVSelectItem } from "@/lib/interfaces/v-select-item.interface";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { TagGoToHelper } from "@/lib/utility/tag.go-to-helper";
import { mixins } from "vue-class-component";
import RulesMixin from "@/mixins/RulesMixin.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import MHeader from "../utility/mmmint/MHeader.vue";
import HasDescription from "../utility/HasDescription.vue";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { icons } from "@/components/utility/IconSelect.vue";
import TagSideCard from "@/components/tag/TagSideCard.vue";

@Component({
  components: {
    HasDescription,
    ConfirmActionDialog,
    MHeader,
    MDetailViewGrid,
    TagChip,
    IconSelect,
    TagSideCard
  }
})
export default class TagDetail extends mixins(RulesMixin) {
  readonly getAutocompleteFilter = getAutocompleteFilter;

  @Prop({ required: true })
  value!: ITag;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  isFormValid = false;

  valueExistsWarning = false;

  isDeleteDialogActive = false;

  isDeleteLoading = false;

  isSaveChangesLoading = false;

  isEdit = false;

  valueCopy = new Tag(this.value);

  view = false;

  get duplicate() {
    const existingTags = TagDataAccessLayer.entities.filter(
      tag => tag.value.toLowerCase() === this.valueCopy.value.toLowerCase() && tag.id !== this.value.id
    );

    if (existingTags.length > 0) {
      return existingTags[0];
    }

    return null;
  }

  get icons(): string[] {
    const options = [""];

    options.push(...icons.map(icon => `mdi-${icon}`));

    return options;
  }

  get valueKey(): keyof Pick<ITag, "value"> {
    return "value";
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }
    const breadCrumbs = TagGoToHelper.breadCrumbs;

    const selected = [];

    selected.push(breadCrumbs.TagTable(this.value.partnerId));
    selected.push(breadCrumbs.TagDetail(this.value.partnerId, this.value.id));

    return selected;
  }

  get colorItems(): IVSelectItem[] {
    return ConfigModule.color.analyticsColors.map(color => ({
      text: color,
      value: color
    }));
  }

  get resourceItems(): IVSelectItem[] {
    return [{ text: $t("enums.ResourceEnum.COMPANY"), value: ResourceEnum.COMPANY }];
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new TagGoToHelper(this.$router).goToTagDetail({
            partnerId: this.value.partnerId,
            tagId: this.value.id,
            newTab: false
          })
      });
    }

    actions.push({
      text: $t("common.verbs.edit"),
      key: "edit",
      icon: "mdi-pencil",
      color: "",
      exec: this.startEdit
    });

    actions.push({
      key: "delerte",
      icon: "mdi-delete",
      text: $t("delete"),
      color: "error",
      exec: this.openDeleteDialog
    });

    return actions;
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      key: "creationSutemstamp",
      text: this.value.timestamp.createdReadable,
      icon: "mdi-cake-variant-outline",
      color: "primary"
    });

    return chips;
  }

  async checkValueExists() {
    if (!this.value.value) {
      this.valueExistsWarning = false;
      return;
    }

    const existingTags = TagDataAccessLayer.entities.filter(
      tag => tag.id !== this.value.id && tag.value.toLowerCase() === this.value.value.toLowerCase()
    );

    this.valueExistsWarning = existingTags.length > 0;
  }

  toggleAllResources(checked: boolean) {
    if (checked) {
      this.value.resources = [...this.value.availableResources];
    } else {
      this.value.resources = [];
    }
  }

  openDeleteDialog() {
    this.isDeleteDialogActive = true;
    this.isDeleteLoading = false;
  }

  async save() {
    try {
      await this.value.update();
      this.$toast.success("👍");
    } catch (error) {
      handleError(error);
    }
  }

  async onDelete() {
    this.isDeleteLoading = true;
    try {
      await this.value.delete();
      this.$toast.success("👍");
      this.$emit("deleted");
    } catch (error) {
      handleError(error);
    } finally {
      this.isDeleteLoading = true;
    }
  }
  startEdit() {
    this.isEdit = true;
    this.valueCopy = new Tag(this.value);
    this.$nextTick(() => {
      (this.$refs.titleField as any)?.focus();
    });
  }

  valueExistsRule(value: string): string | boolean {
    if (!value) {
      return true;
    }

    const existingTags = TagDataAccessLayer.entities.filter(
      tag => tag.value.toLowerCase() === value.trim().toLowerCase() && tag.id !== this.value.id
    );

    if (!existingTags.length) {
      return true;
    }

    return $t("components.tag.valueExistsWarning");
  }

  async saveChanges() {
    this.isSaveChangesLoading = true;
    try {
      if (!this.isFormValid) {
        this.$toast.error($t("common.validation.formInvalid"));
        return;
      }

      await this.value.updatePartial({
        value: this.valueCopy.value,
        description: this.valueCopy.description,
        resources: this.valueCopy.resources,
        color: this.valueCopy.color,
        icon: this.valueCopy.icon
      });

      this.$emit("updated", this.valueCopy);
      this.isEdit = false;
      this.$toast.success("👍");
    } catch (error) {
      handleError(error);
    } finally {
      this.isSaveChangesLoading = false;
    }
  }

  async abortChanges() {
    this.isEdit = false;
    this.valueCopy = new Tag(this.value);
  }

  setResources() {
    this.valueCopy.resources.splice(0);
    this.valueCopy.resources.push(...this.valueCopy.availableResources);
  }
}
